import React from 'react';

export const Loading = () => {
  return (
    <div className="loader"></div>
  );
};
